import { articleService } from "@/services/api/article.service";
import { articleModel } from "@/models/api/article.model";
import { sharedHelper, alertHelper } from "@/utils";
import i18n from "@/i18n";

export const ARTICLE_MODULE = "api/article";
export const GET_ALL_ARTICLE = "getAllArticle";
export const CREATE_ARTICLE = "createArticle";
export const GET_ARTICLE = "getArticle";
export const UPDATE_ARTICLE = "updateArticle";
export const DELETE_ARTICLE = "deleteArticle";
export const APPROVE_ARTICLE = "approveArticle";
export const REJECT_ARTICLE = "rejectArticle";
export const UPDATE_ARTICLE_ACTIVE_STATUS = "updateArticleActiveStatus";

export const state = {
  list: {
    data: [],
    pagination: {
      pageNumber: 1,
      pageSize: 15,
      lastPage: 1,
      tableRowsCounts: 0,
      total: 0,
    },
  },
  details: {},
  status: { list: true, detail: true, save: true },
};

export const actions = {
  async [UPDATE_ARTICLE_ACTIVE_STATUS](
    { commit, dispatch },
    { uuid, isActive, filter },
  ) {
    commit("requesting", "save");
    try {
      const result = await articleService.updateActiveStatus(uuid, isActive);
      if (!result?.success)
        throw new Error(
          result?.message || i18n.t("label.dashboardArticleStatusError"),
        );
      commit("success");
      alertHelper.alertSuccess({
        message: i18n.t("message.updateXSuccess", [i18n.t("module.article")]),
      });
      await dispatch(GET_ALL_ARTICLE, { filter });
      return result;
    } catch (error) {
      commit("failure");
      alertHelper.alertError({
        message: sharedHelper.getErrorMessage(error),
        title: i18n.t("message.error"),
      });
      return null;
    }
  },
  async [GET_ALL_ARTICLE]({ commit }, { filter }) {
    commit("requesting");
    try {
      const result = await articleService.getAll(filter);
      commit("listSuccess", result);
      return result;
    } catch (error) {
      commit("failure");
      alertHelper.alertError({
        message: sharedHelper.getErrorMessage(error),
        title: i18n.t("message.error"),
      });
      throw error;
    }
  },
  async [CREATE_ARTICLE]({ commit, dispatch }, { data, filter }) {
    commit("requesting", "save");
    try {
      const result = await articleService.store(data);
      commit("success");
      alertHelper.alertSuccess({
        message: i18n.t("label.createX", [i18n.t("message.success")]),
      });
      dispatch(GET_ALL_ARTICLE, { filter });
      return result;
    } catch (error) {
      commit("failure");
      alertHelper.alertError({
        message: sharedHelper.getErrorMessage(error),
        title: i18n.t("message.error"),
      });
      return null;
    }
  },
  async [GET_ARTICLE]({ commit }, { uuid }) {
    commit("requesting", "detail");
    try {
      const result = await articleService.show(uuid);
      commit("detailSuccess", result);
      return result;
    } catch (error) {
      commit("failure");
      alertHelper.alertError({
        message: sharedHelper.getErrorMessage(error),
        title: i18n.t("message.error"),
      });
      return null;
    }
  },
  async [UPDATE_ARTICLE]({ commit, dispatch }, { data, filter }) {
    commit("requesting", "save");
    try {
      const result = await articleService.update(data);
      commit("success");
      alertHelper.alertSuccess({
        message: i18n.t("label.updateX", [i18n.t("message.success")]),
      });
      dispatch(GET_ALL_ARTICLE, { filter });
      return result;
    } catch (error) {
      commit("failure");
      alertHelper.alertError({
        message: sharedHelper.getErrorMessage(error),
        title: i18n.t("message.error"),
      });
      return null;
    }
  },
  async [DELETE_ARTICLE]({ commit, dispatch }, { uuid, filter }) {
    commit("requesting", "save");
    try {
      const result = await articleService.softDelete(uuid);
      commit("success");
      alertHelper.alertSuccess({
        message: i18n.t("message.deleteXSuccess", [i18n.t("module.article")]),
      });
      await dispatch(GET_ALL_ARTICLE, { filter });
      return result;
    } catch (error) {
      commit("failure");
      alertHelper.alertError({
        message: sharedHelper.getErrorMessage(error),
        title: i18n.t("message.error"),
      });
      return null;
    }
  },
  async [APPROVE_ARTICLE]({ commit, dispatch }, { uuid, filter }) {
    commit("requesting", "save");
    try {
      const result = await articleService.updateStatus(uuid, 2);
      if (!result?.success)
        throw new Error(
          result?.message || i18n.t("label.dashboardArticleStatusError"),
        );
      commit("success");
      alertHelper.alertSuccess({
        message: i18n.t("label.articleApprovedSuccess"),
      });
      await dispatch(GET_ALL_ARTICLE, { filter });
      return result;
    } catch (error) {
      commit("failure");
      alertHelper.alertError({
        message: sharedHelper.getErrorMessage(error),
        title: i18n.t("message.error"),
      });
      return null;
    }
  },
  async [REJECT_ARTICLE]({ commit, dispatch }, { uuid, filter }) {
    commit("requesting", "save");
    try {
      const result = await articleService.updateStatus(uuid, 3);
      if (!result?.success)
        throw new Error(
          result?.message || i18n.t("label.dashboardArticleStatusError"),
        );
      commit("success");
      alertHelper.alertSuccess({
        message: i18n.t("label.articleRejectedSuccess"),
      });
      await dispatch(GET_ALL_ARTICLE, { filter });
      return result;
    } catch (error) {
      commit("failure");
      alertHelper.alertError({
        message: sharedHelper.getErrorMessage(error),
        title: i18n.t("message.error"),
      });
      return null;
    }
  },
};

export const mutations = {
  requesting(state, type = "list") {
    state.status[type] = false;
  },
  listSuccess(state, result) {
    state.list.data = (result?.data || []).map(articleModel);
    state.list.pagination = sharedHelper.apiPaginationAdapter(result?.pagination || {});
    state.status.list = true;
  },
  detailSuccess(state, result) {
    const payload = result?.data?.article || result?.data || result?.article || result || {};
    state.details = articleModel(payload);
    state.status.detail = true;
  },
  success(state) {
    state.status = { list: true, detail: true, save: true };
  },
  failure(state) {
    state.status = { list: true, detail: true, save: true };
  },
};
